import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_SPESA_CATEGORIA } from '../../data.const';
import {
  retrieveSpesaCategoriaListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteSpesaCategoriaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_SPESA_CATEGORIA),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        defer(() =>
          from(
            request({
              path: `spesaCategoria`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            switchMap(() => of(retrieveSpesaCategoriaListAction(null))),
            catchError((err) => {
              console.error(`[epic ${DELETE_SPESA_CATEGORIA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default deleteSpesaCategoriaEpic;
